import SurveyContainer from './containers/SurveyContainer/SurveyContainer';

export default function App() {
  return <SurveyContainer />;
}
